import { render, staticRenderFns } from "./CartTipCustomAmount.vue?vue&type=template&id=85d5547c"
import script from "./CartTipCustomAmount.vue?vue&type=script&lang=ts"
export * from "./CartTipCustomAmount.vue?vue&type=script&lang=ts"
import style0 from "./CartTipCustomAmount.vue?vue&type=style&index=0&id=85d5547c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports